<template>
  <v-img :src="src"
         :height="this.$root.windowHeight">
    <v-container class="fill-height">
      <v-col cols="4" align="center" class="hidden-xs-only" v-if="poster">
        <v-card max-width="350">
          <v-img :src="'https://www.themoviedb.org/t/p/original/' + poster">
          </v-img>
        </v-card>
      </v-col>
      <v-col class="sm8 md8 lg8 xl8 xs12" align="center">
        <v-row align="center" justify="center">
          <h1 class="display-1 font-weight-light mb-4 white" v-if="background_text">{{ subtitle }}</h1>
          <h1 class="display-1 font-weight-light mb-4 white--text" v-else>{{ subtitle }}</h1>
        </v-row>
        <v-row justify="center" align="center">
          <h1 class="display-3 font-weight-bold white" v-if="background_text">{{ title }}</h1>
          <h1 class="display-3 font-weight-bold white--text" v-else>{{ title }}</h1>
        </v-row>
      </v-col>
    </v-container>

  </v-img>
</template>

<script>
export default {
  name: "MovieShowcase",
  props: {
    title: {
      default: ''
    },
    subtitle: {
      default: ''
    },
    src: {
      default: ''
    },
    poster: {
      default: ''
    },
    background_text: {
      default: ''
    }
  },
}
</script>

<style scoped>

</style>
